import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  reload: true,
};

const reloadSurveysSlice = createSlice({
  name: "reload",
  initialState,
  reducers: {
    changeReload: (state, action) => {
      state.reload = action.payload;
    },
  },
});

export const { changeReload } = reloadSurveysSlice.actions;
export default reloadSurveysSlice.reducer;
